module.exports = __webpack_public_path__ + "img/icon_recommend.9e6592d2.png";